/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getAllFeedbackDetailsApi,
    getCourseFeedbackWithAnswersApi,
    getStudentFeedbackDetailsApi,
    getSubjectFeedbackWithAnswersApi,
    submitStudentFeedbackApi,
} from "@/api/reportingApi";
import { NonTermViewTypeEnum } from "@/ts/enums/NonTermViewTypeEnum";
import {
    AllFeedbackDetailsApiInterface,
} from "@/ts/interfaces/Reporting/SubjectFeedbackInterface";
import {
    FeedbackFormData,
    StudentFeedbackDetailsResponse,
} from "@/ts/interfaces/Reporting/api/StudentFeedbackApiDetailInterface";

export const getStudentFeedbackDetailsThunk = createAsyncThunk<
    StudentFeedbackDetailsResponse,
    { studentId: number; familyGradeId: number; term: number; type: NonTermViewTypeEnum },
    { rejectValue: string }
>("reporting/feedbackDetails", async ({ studentId, familyGradeId, term, type }, { rejectWithValue }) => {
    try {
        const response = await getStudentFeedbackDetailsApi(studentId, familyGradeId, term, type);
        return response.data;
    } catch (err: any) {
        return rejectWithValue(err?.response?.data?.message || "Failed to load feedback details.");
    }
});

export const getSubjectFeedbackWithAnswersThunk = createAsyncThunk<
    StudentFeedbackDetailsResponse,
    { studentId: number; familyGradeId: number; subjectId: number; term: number; type: NonTermViewTypeEnum; personalLearningPlanId?: number | null },
    { rejectValue: string }
>("reporting/subjectFeedbackWithAnswers", async ({ studentId, familyGradeId, subjectId, term, type, personalLearningPlanId }, { rejectWithValue }) => {
    try {
        const response = await getSubjectFeedbackWithAnswersApi(studentId, familyGradeId, subjectId, term, type, personalLearningPlanId);
        return response.data;
    } catch (err: any) {
        return rejectWithValue(err?.response?.data?.message || "Failed to load subject feedback.");
    }
});

export const getCourseFeedbackWithAnswersThunk = createAsyncThunk<
    StudentFeedbackDetailsResponse,
    { studentId: number; familyGradeId: number; term: number | null; courseId: number; type: NonTermViewTypeEnum; personalLearningPlanId?: number | null },
    { rejectValue: string }
>("reporting/courseFeedbackWithAnswers", async ({ studentId, familyGradeId, term, courseId, type, personalLearningPlanId }, { rejectWithValue }) => {
    try {
        const response = await getCourseFeedbackWithAnswersApi(studentId, familyGradeId, term, courseId, type, personalLearningPlanId);
        return response.data;
    } catch (err: any) {
        return rejectWithValue(err?.response?.data?.message || "Failed to load course feedback.");
    }
});

export const submitStudentFeedbackThunk = createAsyncThunk<
    void,
    FeedbackFormData,
    { rejectValue: string }
>("reporting/submitFeedback", async (feedbackData, { rejectWithValue }) => {
    try {
        await submitStudentFeedbackApi(feedbackData);
    } catch (err: any) {
        return rejectWithValue(err?.response?.data?.message || "Failed to submit feedback.");
    }
});

export const getAllFeedbackDetailsThunk = createAsyncThunk<
    AllFeedbackDetailsApiInterface,
    { studentId: number; familyGradeId: number; term: number; type: NonTermViewTypeEnum },
    { rejectValue: string }
>("reporting/allFeedbackDetails", async ({ studentId, familyGradeId, term, type }, { rejectWithValue }) => {
    try {
        const response = await getAllFeedbackDetailsApi(studentId, familyGradeId, term, type);
        return response.data;
    } catch (err: any) {
        return rejectWithValue(err?.response?.data?.message || "Failed to load all feedback details.");
    }
});
